// The one way to say "add one of these".
//
// WHY IT IS A COMPONENT AND NOT A CLASS STRING. The subscriber page had four tabs that add
// things and three different answers: Users and Locations used an outline button, Lines used
// a solid blue one a size larger, and Devices had no button at all — its picker simply sat
// open on the tab, permanently. Kevin, 2026-08-13: "the operator should have the same
// experience across the tabs when adding and removing."
//
// A shared class string would have drifted the same way the last three did, because nothing
// makes the next tab use it. A component is the thing you reach for when you need a button,
// so the next tab gets the right one for free.

export default function AddButton({ children, onClick, disabled = false, title, ...rest }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className="rounded-md border border-blue-300 px-3 py-1.5 text-xs font-medium text-blue-700
                 hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-50"
      {...rest}
    >
      {children}
    </button>
  );
}
